<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p class="c-text c-text--heading c-text--lg">{{ 'Services.Filter.Select_Conditions' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="modalTagCloseButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div class="o-grid o-grid--center-h">
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<div class="c-tags__wrapper u-ost-md u-no-pt" data-tags-wrapper>
							<div *ngFor="let tag of vm.availableTags" class="c-tag"
									 [ngClass]="{'c-tag--selected' : vm.isTagSelected(tag)}"
									 (click)="vm.selectTag(tag)"
									 style="display: table-cell; height: auto; cursor: pointer">
								<span>{{tag.translation}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
						<button id="submitTagSelectionButton" type="button" class="c-button c-button--s1 c-button--s1" (click)="vm.submit()">
							{{ 'Claim.Submit' | translate }}
						</button>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
